import * as React from "react";
import { Context } from "./_context";
export const SelfEmployedIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2.5a1 1 0 0 1 .895.553l4.004 8.007 4.564-2.904a1.001 1.001 0 0 1 1.514 1.06l-2.223 10a1 1 0 0 1-.976.784H4.223a1 1 0 0 1-.977-.783l-2.222-10a1 1 0 0 1 1.513-1.06l4.564 2.903 4.005-8.007.071-.121A1 1 0 0 1 12 2.5ZM8.395 12.947a1.002 1.002 0 0 1-1.432.397L3.5 11.14 5.025 18h13.95l1.524-6.86-3.462 2.204a1.002 1.002 0 0 1-1.431-.397L12 5.737l-3.605 7.21Z", fill: "currentColor" }));
  return iconset[size];
};
SelfEmployedIcon.iconId = "1yLk9x";
